import { render, staticRenderFns } from "./ConfirmMandate.vue?vue&type=template&id=a10c7704&scoped=true"
import script from "./ConfirmMandate.vue?vue&type=script&lang=js"
export * from "./ConfirmMandate.vue?vue&type=script&lang=js"
import style0 from "./ConfirmMandate.vue?vue&type=style&index=0&id=a10c7704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10c7704",
  null
  
)

export default component.exports